const BLOCKED_TRACKING_HOSTS = ["localhost", "127.0.0.1", "staging.inciteai.com"];
const GOOGLE_ADS_CONVERSION_ID = "11333696455";
const GOOGLE_ADS_SIGN_UP_LABEL = "CPI2CKOAj5wcEMf3qZwq";
const GOOGLE_ADS_PURCHASE_LABEL = "kTJqCKCAj5wcEMf3qZwq";
const X_SIGN_UP_EVENT_ID = "tw-ohy5t-rc4q7";

const isBlockedTrackingHost = () => {
  if (typeof window === "undefined") {
    return true;
  }

  return BLOCKED_TRACKING_HOSTS.includes(window.location.hostname);
};

const dataLayerAvailable = () =>
  typeof window !== "undefined" && Array.isArray(window.dataLayer);

const facebookPixelAvailable = () =>
  typeof window !== "undefined" && typeof window.fbq === "function";

const googleAdsAvailable = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

const xPixelAvailable = () =>
  typeof window !== "undefined" && typeof window.twq === "function";

const trackedEventStorageKey = (dedupeKey) => `incite_tracked_event:${dedupeKey}`;

export const hasTrackedEvent = (dedupeKey) => {
  if (!dedupeKey || typeof window === "undefined") {
    return false;
  }

  try {
    return window.localStorage.getItem(trackedEventStorageKey(dedupeKey)) === "1";
  } catch (_) {
    return false;
  }
};

const markTrackedEvent = (dedupeKey) => {
  if (!dedupeKey || typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(trackedEventStorageKey(dedupeKey), "1");
  } catch (_error) {
    return;
  }
};

const normalizeTrackingEvents = (rawEvents) => {
  if (!rawEvents) {
    return [];
  }

  return Array.isArray(rawEvents) ? rawEvents : [rawEvents];
};

const sendToValue = (label) => `AW-${GOOGLE_ADS_CONVERSION_ID}/${label}`;

const trackGoogleAdsConversion = (payload) => {
  if (!googleAdsAvailable()) {
    return false;
  }

  if (payload.event === "sign_up") {
    window.gtag("event", "conversion", {
      send_to: sendToValue(GOOGLE_ADS_SIGN_UP_LABEL),
    });
    return true;
  }

  if (payload.event === "purchase") {
    window.gtag("event", "conversion", {
      send_to: sendToValue(GOOGLE_ADS_PURCHASE_LABEL),
      value: payload.value,
      currency: payload.currency,
      transaction_id: payload.transaction_id,
      new_customer: true,
    });
    return true;
  }

  return false;
};

const trackXConversion = (payload) => {
  if (!xPixelAvailable()) {
    return false;
  }

  if (payload.event === "sign_up") {
    window.twq("event", X_SIGN_UP_EVENT_ID, {});
    return true;
  }

  return false;
};

export const trackBackendEvents = (rawEvents) => {
  if (isBlockedTrackingHost()) {
    return;
  }

  const events = normalizeTrackingEvents(rawEvents);

  events.forEach((eventPayload) => {
    if (!eventPayload?.event) {
      return;
    }

    const dedupeKey = eventPayload.dedupe_key;
    if (dedupeKey && hasTrackedEvent(dedupeKey)) {
      return;
    }

    const payload = { ...eventPayload };
    delete payload.dedupe_key;

    if (payload.ecommerce && dataLayerAvailable()) {
      window.dataLayer.push({ ecommerce: null });
    }

    if (dataLayerAvailable()) {
      window.dataLayer.push(payload);
    }

    if (payload.event === "sign_up" && facebookPixelAvailable()) {
      window.fbq("track", "SignUp");
    }

    const googleAdsTracked = trackGoogleAdsConversion(payload);
    const xTracked = trackXConversion(payload);

    if (dedupeKey && (dataLayerAvailable() || facebookPixelAvailable() || googleAdsTracked || xTracked)) {
      markTrackedEvent(dedupeKey);
    }
  });
};
